import { render, staticRenderFns } from "./userRequest.vue?vue&type=template&id=53be4478&scoped=true&"
import script from "./userRequest.vue?vue&type=script&lang=js&"
export * from "./userRequest.vue?vue&type=script&lang=js&"
import style0 from "./userRequest.vue?vue&type=style&index=0&id=53be4478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be4478",
  null
  
)

export default component.exports